import React from "react";
import { useDialog } from "../../context/DialogContext";
import { Dialog } from "./Dialog";

/**
 * Renders whichever dialog the provider currently holds. Mount once, inside DialogProvider.
 * A dialog that supplies its own `onClose` owns dismissal; otherwise dismissing just clears it.
 */
const DialogHost: React.FC = () => {
  const { dialog, hideDialog } = useDialog();
  if (!dialog) return null;
  return <Dialog {...dialog} onClose={dialog.onClose ?? hideDialog} />;
};

export default DialogHost;
